export type Side = "player" | "enemy";

export type MoveKind = "attack" | "support";

export interface Move {
  id: string;
  name: string;
  /** Короткий тултип для бокса описания. */
  description: string;
  kind: MoveKind;
  /** Базовый шанс попадания (0..1). Применяется и к атаке, и к support. */
  accuracy: number;
  /**
   * Приоритет: при равной скорости ход с бо́льшим priority идёт первым.
   * Аналог Quick Attack из покемонов.
   */
  priority: number;
  /** Только для kind = "attack". Урон роллится равномерно [min..max]. */
  damageMin?: number;
  damageMax?: number;
  /** Только для kind = "support". */
  heal?: number;
  evadeBuff?: number;
  /** Анимационный ключ позы кетбоя при выполнении команды */
  catboyPose: "kneel" | "crawl" | "purr" | "beg";
  /** Текст-флавор для промаха: "%catboy% %flavorMiss%". */
  flavorMiss: string;
}

export interface PairData {
  id: string;
  catboyName: string;
  girlName: string;
  /** Ключи текстур: idle1, idle2, kneel, crawl1, crawl2, purr, beg, worry, blush1, blush2, run1, run2 */
  catboyKeys: {
    idle1: string;
    idle2: string;
    kneel: string;
    crawl1: string;
    crawl2: string;
    purr: string;
    beg: string;
    worry: string;
    blush1: string;
    blush2: string;
    run1: string;
    run2: string;
  };
  /** Ключи текстур монстродевки */
  girlKeys: {
    idle1: string;
    idle2: string;
    command: string;
    smug: string;
    blush1: string;
    blush2: string;
    run1: string;
    run2: string;
  };
  /** Стороны: player → монстродевка со спины (Лилит), enemy → спереди (Суккуба) */
  girlView: "back" | "front";
  /** Уровень и боевые статы. Формула урона теперь не использует A/D
   *  напрямую (урон задаётся min/max в Move), но статы пригодятся для
   *  будущих усложнений. Speed решает порядок ходов в раунде. */
  level: number;
  attackStat: number;
  defenseStat: number;
  speedStat: number;
  maxHp: number;
}

export enum BattleState {
  Intro,
  PlayerMenu,
  PlayerCommandSelect,
  PlayerActionAnim,
  EnemyTurn,
  EnemyActionAnim,
  CheckKO,
  BattleEnd,
}
